import { Component, OnInit, EventEmitter, Output, Input, ViewChild, ElementRef, ViewEncapsulation } from '@angular/core';
import { Subject } from "rxjs/Subject";
import 'rxjs/add/operator/debounceTime';

@Component({
    selector: 'simple-timepicker',
    encapsulation: ViewEncapsulation.None,
    template: `
<div class="simple_content">
    <div class="label">{{label}}</div>
    <div class="input_wrap" >
        <mat-form-field>
            <input matInput [value]="hour" (input)="hour$.next($event.target.value)" tabindex="{{id+1}}"/>
        </mat-form-field>
        <div class="col"> : </div>
        <mat-form-field>
            <input matInput [value]="minute" (input)="minute$.next($event.target.value)"  tabindex="{{id+2}}"/>
        </mat-form-field>
        <div class="col">&nbsp;</div>
        <mat-form-field class="med">
            <mat-select [(ngModel)]="meridiem" tabindex="{{id+3}}">
                <mat-option value="am">am</mat-option>
                <mat-option value="pm">pm</mat-option>
            </mat-select>
        </mat-form-field>
    </div>
 </div>
`,
    styles: [`
:host { font-family:Ubuntu; font-size:14px; width:100px; }
.simple_content .label { font-family:Ubuntu; font-size:14px; color:#333; width:200px; margin-bottom:10px; }
.simple_content .input_wrap { display:flex; align-items:baseline; }
.simple_content .input_wrap .mat-form-field { width:48px; font-family:Ubuntu; font-size:14px; }
.simple_content .input_wrap .mat-form-field.med { width:75px; text-align: center; }
.simple_content .input_wrap .mat-select-trigger { width:70px; padding-bottom:2px; }
.simple_content .input_wrap .mat-input-element { text-align:center; font-family:Ubuntu; font-size:14px; }
.simple_content .input_wrap .col { width:20px; color:#999; display: block; text-align: center; }
`]
})

export class SimpleTimePickerComponent implements OnInit {

    hour$ = new Subject<any>();
    minute$ = new Subject<any>();
    @Input() id: any;
    @Input() label: string;
    @Input() value: string;
    @Output() valueChange = new EventEmitter<any>();

    @ViewChild('hhRef, mmRef', {read: ElementRef}) hourInput;
    ngOnInit() {
        this.hour$.debounceTime(500).subscribe( h => this.hour = h);
        this.minute$.debounceTime(500).subscribe( m => this.minute = m);
    }

    get datetime() {
        if (!this.value || this.value=='' || this.value.match(/^\d{1,2}:\d{1,2}[a|p]m$/i)==null) this.value = '00:00am';
        let t = this.value.toLowerCase();
        return t;
    }
    get hour():string {
        let hh = this.datetime.match(/^(\d{1,2}):\d{1,2}[a|p]m$/i)[1];
        return ('0' + hh).slice(-2);
    }
    set hour(hh) {
        let x = ('0' + hh).slice(-2)
        this.value = this.value.replace(/^(.*):/, x+':');
        this.valueChange.emit(this.value.toLowerCase());
    }
    get minute():string|number  {
        let mm = this.datetime.match(/^\d{1,2}:(\d{1,2})[a|p]m$/i)[1];
        return ('0' + mm).slice(-2);
    }
    set minute(mm) {
        let x = ('0' + mm).slice(-2);
        this.value = this.value.replace(/:(.*)(am|pm)/i, ':'+ x +'$2');
        this.valueChange.emit(this.value.toLowerCase());
    }
    get meridiem() {
        return  this.datetime.match(/^\d{1,2}:\d{1,2}([a|p]m)$/i)[1];
    }
    set meridiem(m) {
        this.value = this.value.replace(/(am|pm)/i, m.toLowerCase());
        this.valueChange.emit(this.value.toLowerCase());
    }
}



// WEBPACK FOOTER //
// ./src/app/shared/simple-timepicker.ts